import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as Mui from "@mui/material";
import { userManagementError } from "services/constants/ErrorMessages";
import { themes } from "services/constants";
import { showToast } from "services/utils/Status";
import { useForm } from "react-hook-form";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { AddBoxOutlined, Delete, Info } from "@mui/icons-material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { setProductAccess } from "services/Redux/userToken";
import { customGetAPI } from "services/utils/CustomAPI";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { BackArrow } from "components/CustomComponents/BackArrow";
import sessionHandling from "services/utils/notificationUtils";
import { formKeyText, tooltipStyleProps } from "services/constants/Styles";
import { setCompanyList } from "services/Redux/userToken";
import { customGetAPIWithToken } from "services/utils/CustomAPI";
import { setTopbarCompanyName } from "services/Redux/userToken";

export const AddCompany = ({
  screenName,
  editEompanyDetails: editCompanyDetails,
  setAddCompanyScreen,
  updateData,
  setUpdateData,
  companyDetails,
  setGetCompanyDetails,
  setCompanyApi,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
    trigger,
  } = useForm({
    mode: "onBlur",
  });
  const { domain, token, userDetails, topbarCompanyId } = useSelector(
    (state) => state.tokenReducer
  );
  const [yesCheck, setYesCheck] = useState(false);
  const [noCheck, setNoCheck] = useState(true);
  const [logoFile, setLogoFile] = useState(null);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [logoPreview, setLogoPreview] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (updateData) {
      setValue("companyname", editCompanyDetails.companyname);
      setValue("companycode", editCompanyDetails.companycode);
      setValue("gstno", editCompanyDetails.gstno);
      setValue("address", editCompanyDetails.address);
      setValue("email", editCompanyDetails.email);
      setValue("phoneno", editCompanyDetails.phonenumber);
      setUpdateData(false);
      if (editCompanyDetails.gstno !== "" && editCompanyDetails.gstno) {
        setYesCheck(true);
        setNoCheck(false);
      }
    }
    if (
      editCompanyDetails.company_logo_url &&
      editCompanyDetails.company_logo_url.trim() !== ""
    ) {
      setLogoPreview(editCompanyDetails.company_logo_url);
    } else {
      setLogoPreview("");
    }
  }, [
    editCompanyDetails.address,
    editCompanyDetails.companycode,
    editCompanyDetails.companyname,
    editCompanyDetails.email,
    editCompanyDetails.endDate,
    editCompanyDetails.gstno,
    editCompanyDetails.phonenumber,
    setUpdateData,
    setValue,
    updateData,
    editCompanyDetails.company_logo_url,
  ]);

  const getProductAccess = useCallback(
    async (userId) => {
      const res = await customGetAPI(`${domain}products/?user_id=${userId}`);
      if (res.ok) {
        dispatch(setProductAccess(res.responseDetails));
        localStorage.setItem(
          "productAccess",
          JSON.stringify(res.responseDetails)
        );
      }
    },
    [dispatch, domain]
  );

  const refreshCompanyAccess = async () => {
    const companyAccess = await customGetAPIWithToken(
      `${domain}user-group/user/company/?user_id=${userDetails.id}`,
      token
    );

    if (companyAccess.ok) {
      dispatch(setCompanyList(companyAccess.responseDetails));
      localStorage.setItem(
        "companyAccess",
        JSON.stringify(companyAccess.responseDetails)
      );
    }
  };

  const onSubmit = async (data) => {
    if (isSubmitting || buttonLoader) {
      return;
    }

    setIsSubmitting(true);

    if (logoFile && logoFile.size > 1000000) {
      showToast("error", userManagementError.imagesizeError);
      setIsSubmitting(false);
      return;
    } else {
      setButtonLoader(true);
      if (data) {
        const apiActionMethod =
          screenName === "Edit Company Details" ? "PUT" : "POST";
        const apiUrl =
          screenName === "Edit Company Details"
            ? `${domain}company/${editCompanyDetails?.id}/`
            : `${domain}company/`;
        try {
          const myHeaders = new Headers();
          const formData = new FormData();
          myHeaders.append("Authorization", `token ${token}`);
          if (logoFile) {
            formData.append("company_logo", logoFile, logoFile.name);
          }
          formData.append("companyname", data.companyname);
          formData.append("company_code", data.companycode);
          formData.append("address", data.address);
          formData.append("gstnumber", data.gstno);
          formData.append("email", data.email);
          formData.append("isactive", true);
          formData.append("phonenumber", data.phoneno);
          formData.append("isprimary", editCompanyDetails.primary);
          const response = await fetch(apiUrl, {
            method: apiActionMethod,
            headers: myHeaders,
            body: formData,
            redirect: "follow",
          });
          const res = await response.json();
          if (response.ok) {
            await refreshCompanyAccess();
            if (topbarCompanyId === editCompanyDetails?.id) {
              dispatch(setTopbarCompanyName(data.companyname));
            }
            if (companyDetails.length === 0) {
              showToast("success", "Company created successfully");
              await getProductAccess(userDetails.id);
              reset();
              dispatch(setGlobalSearchValue(""));
              history.push("/admin/administration/user");
            } else {
              showToast(
                "success",
                screenName === "Edit Company Details"
                  ? "Company updated successfully"
                  : "Company created successfully"
              );
              reset();
              setGetCompanyDetails(true);
              setAddCompanyScreen(false);
              setCompanyApi(true);
            }
          } else if (response.status === 409) {
            sessionHandling();
          } else {
            throw new Error(res.error);
          }
        } catch (error) {
          showToast("error", error.message);
        } finally {
          setButtonLoader(false);
          setIsSubmitting(false);
        }
      }
    }
  };

  const handleKeyPress = (e) => {
    const charCode = e.charCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const setYesCheckUpdated = () => {
    if (yesCheck) {
      setNoCheck(true);
      setYesCheck(false);
      setValue("gstno", "");
    } else {
      setYesCheck(true);
      setNoCheck(false);
    }
  };

  const setNoCheckUpdated = () => {
    if (noCheck) {
      setNoCheck(false);
      setYesCheck(true);
    } else {
      setNoCheck(true);
      setYesCheck(false);
      setValue("gstno", "");
    }
  };

  const handleKeyDown = (e) => {
    const allowedKeys = /^[A-Za-z\s 0-9]$/;
    if (!allowedKeys.test(e.key)) {
      e.preventDefault();
    }
  };

  const checkSpecialChar = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const removeCompany = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      const myHeaders = new Headers();
      const formData = new FormData();
      myHeaders.append("Authorization", `token ${token}`);
      formData.append("isdeleted", true);
      const response = await fetch(
        `${domain}company/${editCompanyDetails?.id}/`,
        {
          method: "PUT",
          headers: myHeaders,
          body: formData,
          redirect: "follow",
        }
      );
      const res = await response.json();
      if (response.ok) {
        setGetCompanyDetails(true);
        setAddCompanyScreen(false);
        showToast("success", "Company updated successfully");
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      showToast("error", error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const validateGST = (gstNo) => {
    const regex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
    return regex.test(gstNo);
  };

  const checkExistingCompanyName = useCallback(
    async (companyName) => {
      try {
        const response = await fetch(
          `${domain}check_company_name/?company_name=${companyName}`,
          {
            method: "GET",
            headers: {
              "content-type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          if (res?.exists) {
            return "That company name is already taken. Please choose a unique name.";
          } else {
            return true;
          }
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    },
    [domain, token]
  );

  const checkExistingCompanyCode = useCallback(
    async (companyCode) => {
      try {
        const response = await fetch(
          `${domain}check_company_name/?company_code=${companyCode}`,
          {
            method: "GET",
            headers: {
              "content-type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          if (res?.exists) {
            return "That company code is already taken.Please choose a unique code.";
          } else {
            return true;
          }
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    },
    [domain, token]
  );

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const img = new Image();
    img.onload = () => {
      if (img.width > 200 || img.height > 45) {
        showToast(
          "error",
          "Logo should not exceed 200px width or 45px height."
        );
        return;
      }
      setLogoFile(file);
      setLogoPreview(URL.createObjectURL(file));
    };
    img.src = URL.createObjectURL(file);
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Mui.Grid xs={12}>
          <Mui.Grid container>
            {companyDetails.length !== 0 ? (
              <BackArrow actionFunction={() => setAddCompanyScreen(false)} />
            ) : null}
            &nbsp;
            <Mui.Typography
              sx={{
                fontSize: 30,
                fontWeight: "bold",
                color: themes.headLine,
                paddingLeft: companyDetails.length !== 0 ? 1 : 0,
              }}
            >
              {screenName}
            </Mui.Typography>
          </Mui.Grid>
        </Mui.Grid>
        {companyDetails.length === 0 ? (
          <Mui.Grid xs={12}>
            <Mui.Typography>
              Atleast one company is required,Fill in the form to create the
              first company
            </Mui.Typography>
          </Mui.Grid>
        ) : null}
        <br />
        <Mui.Grid
          container
          sx={{
            paddingTop: "2%",
            paddingLeft: "10%",
            paddingRight: "10%",
          }}
        >
          <Mui.Grid
            container
            sx={{
              padding: 1,
              backgroundColor: themes.primary,
              borderRadius: "10px 10px 0 0",
              border: `2px solid ${themes.sidebarDivider}`,
              borderBottom: "none",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Mui.Grid xs={4}>
              <Mui.Typography
                sx={{
                  fontSize: 24,
                  fontWeight: 800,
                  font: "bold",
                  textAlign: "center",
                }}
              >
                {screenName === "Edit Company Details"
                  ? "Edit Company"
                  : "Create Company"}
              </Mui.Typography>
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid
            container
            sx={{
              border: `2px solid ${themes.sidebarDivider}`,
              padding: 2,
              borderRadius: "0 0 10px 10px",
            }}
          >
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={4}>
                <Mui.Typography sx={formKeyText}>
                  Company Name&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title={
                      screenName === "Edit Company Details"
                        ? "Update the legal or display name of the company as required."
                        : "Enter the official/legal name of your company."
                    }
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={8}>
                <Mui.TextField
                  {...register("companyname", {
                    required: "Company name is required",
                    maxLength: {
                      value: 32,
                      message: "Maximum length is 32 characters",
                    },
                    minLength: {
                      value: 3,
                      message: "Minimum length is 3 characters",
                    },
                    validate: {
                      companyName: async (fieldValue) => {
                        if (!/[A-Za-z]/.test(fieldValue)) {
                          return "Company name must contain at least one alphabet character.";
                        } else if (/^\d+$/.test(fieldValue)) {
                          return "Company name should not contain digits.";
                        } else if (
                          fieldValue !== "" &&
                          screenName === "Create Company"
                        ) {
                          return await checkExistingCompanyName(
                            fieldValue.trim()
                          );
                        } else if (
                          fieldValue !== "" &&
                          fieldValue !== editCompanyDetails.companyname &&
                          screenName === "Edit Company Details"
                        ) {
                          return await checkExistingCompanyName(
                            fieldValue.trim()
                          );
                        } else {
                          return true;
                        }
                      },
                    },
                  })}
                  error={errors.companyname ? true : false}
                  helperText={errors.companyname?.message}
                  sx={{ background: themes.whiteColor }}
                  onKeyPress={handleKeyDown}
                  name="companyname"
                  placeholder="Enter company name"
                  size="small"
                  fullWidth
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={4}>
                <Mui.Typography sx={formKeyText}>
                  Company Code&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title={
                      screenName === "Edit Company Details"
                        ? "Modify the unique identifier for the company if needed.(Note: Ensure this remains unique to avoid conflicts.)"
                        : "Provide a unique code to identify the company within the system.Example: ABC001"
                    }
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={8}>
                <Mui.TextField
                  {...register("companycode", {
                    required: "Company code is required",
                    minLength: {
                      value: 3,
                      message: "At least 3 characters required",
                    },
                    validate: {
                      companyCode: async (fieldValue) => {
                        const cleanedValue = fieldValue.replace(
                          /[a-zA-Z^-]/g,
                          ""
                        );
                        setValue("companycode", cleanedValue);

                        if (
                          cleanedValue !== "" &&
                          screenName === "Create Company"
                        ) {
                          return await checkExistingCompanyCode(
                            cleanedValue.trim()
                          );
                        } else if (
                          cleanedValue !== "" &&
                          cleanedValue !== editCompanyDetails.companycode &&
                          screenName === "Edit Company Details"
                        ) {
                          return await checkExistingCompanyCode(
                            cleanedValue.trim()
                          );
                        } else {
                          return true;
                        }
                      },
                    },
                  })}
                  error={errors.companycode ? true : false}
                  helperText={errors.companycode?.message}
                  sx={{ background: themes.whiteColor }}
                  name="companycode"
                  placeholder="Enter company code"
                  onKeyPress={checkSpecialChar}
                  InputProps={{
                    inputProps: { maxLength: 3 },
                  }}
                  fullWidth
                  size="small"
                  onBlur={async () => {
                    await trigger("companycode");
                  }}
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={4}>
                <Mui.Typography sx={formKeyText}>
                  Is GST Registered&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title={
                      screenName === "Edit Company Details"
                        ? "Toggle between Yes or No to update the GST registration status of the company.Changing this may affect tax-related processes."
                        : "Select whether the company is registered under GST by choosing Yes or No.This will impact tax calculations and compliance."
                    }
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={8}>
                <Mui.Stack direction="Row">
                  <Mui.Grid sx={{ marginTop: -1 }}>
                    <Mui.Checkbox
                      checked={yesCheck}
                      onChange={() => setYesCheckUpdated()}
                    />
                  </Mui.Grid>
                  <Mui.Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                    Yes
                  </Mui.Typography>
                  <Mui.Grid sx={{ marginTop: -1 }}>
                    <Mui.Checkbox
                      checked={noCheck}
                      onChange={() => setNoCheckUpdated()}
                    />
                  </Mui.Grid>
                  <Mui.Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                    No
                  </Mui.Typography>
                </Mui.Stack>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: yesCheck ? 1 : 0 }}>
              <Mui.Grid xs={4}></Mui.Grid>
              <Mui.Grid xs={8}>
                {yesCheck ? (
                  <Mui.TextField
                    {...register("gstno", {
                      required: yesCheck ? "Gstno is required" : false,
                      validate: {
                        gstNoValidation: async (fieldValue) => {
                          if (fieldValue !== "" && !noCheck) {
                            const valid = validateGST(fieldValue);
                            return valid
                              ? true
                              : "GSTNO in format 22AAAAA0000A1Z5";
                          }
                        },
                      },
                    })}
                    error={errors.gstno ? true : false}
                    helperText={errors.gstno?.message}
                    sx={{ background: themes.whiteColor }}
                    name="gstno"
                    placeholder="GSTNO in format 00AAAAA0000A0A0"
                    onKeyPress={handleKeyDown}
                    disabled={yesCheck ? false : true}
                    InputProps={{
                      inputProps: { maxLength: 15 },
                    }}
                    size="small"
                    fullWidth
                  />
                ) : null}
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={4}>
                <Mui.Typography sx={formKeyText}>
                  Email&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title={
                      screenName === "Edit Company Details"
                        ? "Update the official company email address used for notifications and reports."
                        : "Enter the official email ID of the company for communication and report delivery."
                    }
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={8}>
                <Mui.TextField
                  id="email"
                  variant="outlined"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid e-mail address",
                    },
                  })}
                  error={Boolean(errors.email)}
                  helperText={errors.email?.message || ""}
                  placeholder="Enter email"
                  size="small"
                  fullWidth
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={4}>
                <Mui.Typography sx={formKeyText}>
                  Phone Number&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title={
                      screenName === "Edit Company Details"
                        ? "Edit the company's contact number for support, alerts, or internal communication."
                        : "Input a valid contact number that can be used for support and verification."
                    }
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={8}>
                <Mui.TextField
                  {...register("phoneno", {
                    required: "Phone number is required",
                    minLength: {
                      value: 10,
                      message: "Minimum length is 10 digits",
                    },
                    maxLength: {
                      value: 15,
                      message: "Maximum length is 15 digits",
                    },
                    validate: {
                      formatCheck: (value) => {
                        const cleanedValue = value.replace(/[^\d-]/g, "");
                        setValue("phoneno", cleanedValue);
                        return true;
                      },
                    },
                  })}
                  error={errors.phoneno ? true : false}
                  helperText={errors.phoneno?.message}
                  sx={{ background: themes.whiteColor }}
                  name="phoneno"
                  onBlur={async () => {
                    await trigger("phoneno");
                  }}
                  placeholder="Enter phone number"
                  onKeyPress={handleKeyPress}
                  fullWidth
                  size="small"
                  InputProps={{
                    inputProps: { maxLength: 15 },
                  }}
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={4}>
                <Mui.Typography sx={formKeyText}>
                  Address&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title={
                      screenName === "Edit Company Details"
                        ? "Modify the company's main office or billing address as necessary."
                        : "Type the full postal address of the company's main office or headquarters."
                    }
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={8}>
                <Mui.TextField
                  multiline
                  rows={2}
                  maxRows={5}
                  {...register("address", {
                    required: "Address is required",
                  })}
                  error={errors.address ? true : false}
                  helperText={errors.address?.message}
                  sx={{ background: themes.whiteColor }}
                  name="address"
                  placeholder="Enter address"
                  size="small"
                  fullWidth
                />
                {companyDetails.length === 0 ? (
                  <Mui.Stack sx={{ paddingTop: 2 }}>
                    <Mui.Typography>
                      <label style={{ color: themes.redColor, fontSize: 25 }}>
                        *
                      </label>
                      Additional companies can be created under admin page
                    </Mui.Typography>
                  </Mui.Stack>
                ) : null}
              </Mui.Grid>
            </Mui.Grid>
            {editCompanyDetails.isactive ? (
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{ paddingTop: 1 }}
                >
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title={
                      screenName === "Edit Company Details"
                        ? "You can change or remove the existing logo. Upload a new one if needed."
                        : "(Optional) Upload the company logo. It will appear on payslips and reports."
                    }
                  >
                    <Mui.Tooltip arrow>
                      <Mui.Button
                        variant="outlined"
                        component="label"
                        sx={{
                          alignItems: "center",
                          textTransform: "capitalize",
                          border: `1px solid ${themes.borderShadowColor}`,
                        }}
                        size="small"
                        fullWidth
                        disabled={isSubmitting}
                      >
                        <Mui.Stack>
                          <AddBoxOutlined
                            sx={{
                              marginLeft: 3,
                              fontSize: 25,
                              color: themes.headLine,
                            }}
                          />
                          <Mui.Typography
                            fontSize={18}
                            sx={{
                              textTransform: "none",
                              color: themes.headLine,
                            }}
                          >
                            Add Logo
                          </Mui.Typography>
                        </Mui.Stack>
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={handleLogoChange}
                          disabled={isSubmitting}
                        />
                      </Mui.Button>
                    </Mui.Tooltip>
                    <Mui.Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        mt: 1,
                        textAlign: "center",
                        color: "gray",
                      }}
                    >
                      Recommended size: 200 × 45 px
                    </Mui.Typography>

                    <Mui.Box
                      sx={{ mt: 2, display: "flex", justifyContent: "center" }}
                    >
                      {logoFile ? (
                        <img
                          src={URL.createObjectURL(logoFile)}
                          alt="Uploaded Logo"
                          style={{ maxWidth: "200px", maxHeight: "45px" }}
                        />
                      ) : logoPreview ? (
                        <img
                          src={logoPreview}
                          alt="Existing Logo"
                          style={{ maxWidth: "200px", maxHeight: "45px" }}
                        />
                      ) : (
                        <Mui.Typography
                          sx={{
                            width: "200px",
                            height: "45px",
                            border: "1px solid #ccc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {editCompanyDetails?.companyname || "No Logo"}
                        </Mui.Typography>
                      )}
                    </Mui.Box>
                  </Mui.Tooltip>
                </Mui.Grid>
              </Mui.Grid>
            ) : (
              <Mui.Box
                elevation={5}
                sx={{ border: "1px solid red", borderRadius: 4, padding: 1 }}
              >
                <Mui.Grid item sx={{ paddingLeft: 2 }}>
                  <Mui.Typography
                    sx={{ fontSize: 25, fontWeight: "bold", paddingBottom: 1 }}
                  >
                    Delete Company
                  </Mui.Typography>
                  <Mui.Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: "normal",
                      paddingBottom: 1,
                    }}
                  >
                    Deleting the company will permanently remove all data and
                    revoke access for all associated users.
                  </Mui.Typography>
                  <Mui.Grid container>
                    <Mui.Grid item xs={5.5}></Mui.Grid>
                    <Mui.Grid item xs={1}>
                      <Mui.Button
                        sx={{
                          backgroundColor: themes.redColor,
                          "&:hover": {
                            backgroundColor: themes.redColor,
                          },
                          color: themes.whiteColor,
                          padding: 1,
                        }}
                        size="small"
                        variant="varient"
                        onClick={() => removeCompany()}
                        disabled={isSubmitting}
                      >
                        Delete&nbsp;&nbsp;
                        <Delete sx={{ color: themes.headLine }} />
                      </Mui.Button>
                    </Mui.Grid>
                    <Mui.Grid item xs={5.5}></Mui.Grid>
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Box>
            )}
            {editCompanyDetails.isactive ? (
              <Mui.Grid container sx={{ paddingTop: 2 }}>
                <Mui.Grid xs={12} sm={6} md={6} lg={11}></Mui.Grid>
                <Mui.Grid
                  xs={12}
                  sm={6}
                  md={6}
                  lg={1}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <CustomButton
                    actionName={
                      screenName === "Create Company" ? "Create" : "Update"
                    }
                    typeName="submit"
                    disableAction={isSubmitting || buttonLoader}
                  />
                </Mui.Grid>
              </Mui.Grid>
            ) : null}
          </Mui.Grid>
        </Mui.Grid>
      </form>
    </React.Fragment>
  );
};
